export default "__VITE_ASSET__B2wc21hI__"